<div class="container mx-auto px-0 py-0">
  <div class="bg-white rounded-lg" [ngClass]="{'shadow-md p-6': !isEmbedded, 'p-0': isEmbedded}">
    <!-- Standalone Header - Only show in standalone mode -->
    <div *ngIf="!isEmbedded" class="flex justify-between items-center mb-6">
      <div class="flex items-center space-x-2">
        <mat-icon>folder</mat-icon>
        <h2 class="text-2xl font-bold mb-0">Dokumente</h2>
      </div>
      <div class="flex justify-end">
        <button 
          (click)="addDokument()" 
          mat-stroked-button>
          <mat-icon class="mr-1">add</mat-icon>
          Dokument hinzufügen
        </button>
      </div>
    </div>
    
    <!-- Embedded Header - Only show in embedded mode -->


    <!-- Search Bar - Show in standalone mode or when embedded in system-settings -->
    <div *ngIf="!isEmbedded || parentContext === 'system-settings'" class="mb-4">
      <div class="w-full max-w-sm min-w-[200px]">
        <div class="relative">
          <input
            class="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md pl-3 pr-28 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
            placeholder="Suche Dokument..." 
            [(ngModel)]="searchValue"
            (keyup)="onSearchInput($event)"
          />
          <button
            class="absolute top-1 right-1 flex items-center rounded bg-slate-800 py-1 px-2.5 border border-transparent text-center text-sm text-white transition-all shadow-sm hover:shadow focus:bg-slate-700 focus:shadow-none active:bg-slate-700 hover:bg-slate-700 active:shadow-none disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button"
            *ngIf="searchValue"
            (click)="clearSearch()"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4 mr-2">
              <path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
            </svg>
            Clear
          </button>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoadingResults" class="flex justify-center items-center py-8">
      <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
      <span class="ml-4 text-gray-600">Lade Dokumente...</span>
    </div>

    <!-- Error Message -->
    <div *ngIf="isRateLimitReached" class="text-red-500 text-center py-4">
      Fehler beim Laden der Dokumente. Bitte versuchen Sie es später erneut.
    </div>

    <!-- Documents Table -->
    <div class="mt-8 flow-root" *ngIf="!isLoadingResults && !isRateLimitReached">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="min-w-full divide-y divide-gray-300 dark:divide-white/15">
            <thead>
              <tr>
                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0 dark:text-white">Dateiname</th>
                <th *ngIf="isClientView" scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Standort</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Typ / Größe</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Hochgeladen von</th>
                <th scope="col" class="px-2 py-3.5 text-left text-sm font-semibold text-gray-900 dark:text-white">Datum</th>
                <th scope="col" class="py-3.5 pl-3 pr-4 sm:pr-0">
                  <span class="sr-only">Actions</span>
                </th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white dark:divide-white/10 dark:bg-gray-900">
              <tr 
                *ngFor="let dokument of dataSource.data; let i = index" 
                class="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150"
                [ngClass]="{'bg-gray-50 dark:bg-gray-800': i % 2 === 1}">
                <td class="py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0 dark:text-white">
                  <div class="flex items-start">
                    <img
                      *ngIf="isImage(dokument); else fileTypeIcon"
                      [src]="getImageUrl(dokument)"
                      [alt]="dokument.original_filename"
                      class="dokument-thumbnail mr-2 flex-shrink-0"
                      (click)="openGallery(dokument)"
                      (error)="onThumbnailError($event)"
                      matTooltip="Bild anzeigen"
                      matTooltipPosition="above">
                    <ng-template #fileTypeIcon>
                      <mat-icon class="mr-2 text-gray-400 mt-0.5 flex-shrink-0">{{ getFileTypeIcon(dokument.mime_type) }}</mat-icon>
                    </ng-template>
                    <div class="min-w-0 flex-1">
                      <div class="break-words" [class.dokument-image-name]="isImage(dokument)" (click)="openGallery(dokument)">{{ dokument.original_filename }}</div>
                      <div *ngIf="dokument.description" class="text-xs italic text-gray-500 dark:text-gray-400 break-words">{{ dokument.description }}</div>
                    </div>
                  </div>
                </td>
                <td *ngIf="isClientView" class="px-2 py-2 text-sm text-gray-700 dark:text-gray-200">
                  <div class="break-words">{{ dokument.standort_name || '-' }}</div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div>
                    <div class="font-medium break-words">{{ getDisplayCategory(dokument.mime_type) }}</div>
                    <div class="text-xs">{{ formatFileSize(dokument.file_size) }}</div>
                  </div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="break-words">{{ dokument.user_full_name || dokument.user_name || 'Unbekannt' }}</div>
                </td>
                <td class="px-2 py-2 text-sm text-gray-500 dark:text-gray-400">
                  <div class="break-words">{{ dokument.uploadDate | date:'dd.MM.yyyy' }}</div>
                </td>
                <td class="py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                  <div class="flex space-x-2 justify-end items-center">
                    <button
                      *ngIf="isCompAdmin"
                      (click)="deleteDokument(dokument)"
                      mat-icon-button
                      [matTooltip]="'Datei löschen'"
                      matTooltipPosition="above"
                      class="flex-shrink-0"
                      style="width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center;">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #6b7280; line-height: 1;">delete</mat-icon>
                    </button>
                    <button
                      (click)="downloadDokument(dokument)"
                      mat-button
                      color="primary"
                      class="slim-button flex-shrink-0">
                      Download
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="!isLoadingResults && !isRateLimitReached"
      [length]="totalItems"
      [pageSizeOptions]="pageSizes"
      [pageSize]="currentPageSize"
      [pageIndex]="currentPageIndex"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Select page of documents">
    </mat-paginator>

    <!-- Empty State -->
    <div *ngIf="!isLoadingResults && !isRateLimitReached && dataSource.data.length === 0" class="text-center py-8">
      <mat-icon class="text-gray-400 text-6xl mb-4">folder</mat-icon>
      <p class="text-gray-500 text-lg">Keine Dokumente gefunden</p>
      <p class="text-gray-400">Fügen Sie das erste Dokument hinzu, um zu beginnen.</p>
    </div>

    <div *ngIf="isEmbedded && !isClientView && !!recordId" class="mb-4 mt-4">
        <div class="mb-4">
          <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Dateien hochladen
          </label>
          <file-pond
            #myPond
            [options]="pondOptions"
            [files]="pondFiles"
            (oninit)="pondHandleInit()"
            (onaddfile)="pondHandleAddFile($event)"
            (onprocessfiles)="onProcessFiles($event)"
            (onactivatefile)="pondHandleActivateFile($event)">
          </file-pond>
        </div>
      </div>
  </div>
</div>
